import { z } from 'zod';
import { FlowDefinitionTemplateMetadataSchema } from './metadata.js';
import { FlowDefinitionTemplateVisibility } from './visibility.js';
import { FlowDataSchema } from '../flowDefinition/flowData.js';
import { FlowDefinitionState } from '../flowDefinition/flowDefinition.js';
export const FlowDefinitionTemplateTagSchema = z.object({
    name: z.string(),
    category: z.string(),
});
/**
 * A flow template is stored as a flow of kind FlowTemplate whose live flow definition holds the
 * template content, so these fields come from all three tables.
 */
const FlowDefinitionTemplateBaseSchema = z.object({
    id: z
        .uuid()
        .describe('Template identifier, which is also the identifier of the flow the template is stored as.'),
    name: z.string(),
    content: z.string().nullish().describe('Short summary of what the template does.'),
    detailedContentMarkdown: z
        .string()
        .nullish()
        .describe('Markdown documentation for the template, written for a person adopting it.'),
    organizationId: z.uuid(),
    visibility: z.enum(FlowDefinitionTemplateVisibility),
    state: z
        .enum(FlowDefinitionState)
        .describe('Publication state of the template definition. Callers without a template-management permission only ever see Published templates.'),
    version: z.number().int().nonnegative().describe('Version of the template definition.'),
    flowDefinitionId: z.uuid().describe('Flow definition holding the template block graph.'),
    tags: z
        .array(FlowDefinitionTemplateTagSchema)
        .describe('Categorized tags the template library organizes templates by.'),
    metadata: FlowDefinitionTemplateMetadataSchema.nullish().describe('Presentation metadata for the template library, such as a case study, demo video, or featured status.'),
    thumbnailUrl: z.string().optional().describe('Present only when the template has a thumbnail.'),
    createdById: z.uuid().nullish(),
    updatedById: z.uuid().nullish(),
    createdByEmail: z.string().nullish(),
    created: z.iso.datetime(),
    updated: z.iso
        .datetime()
        .describe('When the underlying flow record was last written. Edits that touch only the template row, its definition, or its tags do not advance it, so treat it as a lower bound rather than the last edit.'),
});
export const FlowDefinitionTemplateListItemSchema = FlowDefinitionTemplateBaseSchema.extend({
    isBookmarked: z
        .boolean()
        .optional()
        .describe('Whether the requesting user has bookmarked this template.'),
}).describe('One template in the library, without its block graph. Retrieve the template by id for the graph.');
export const FlowDefinitionTemplateSchema = FlowDefinitionTemplateBaseSchema.extend({
    data: FlowDataSchema.describe('The block graph a flow created from this template starts as.'),
}).describe('One template in the library, including the block graph it would create.');
//# sourceMappingURL=flowDefinitionTemplate.js.map